import { Dispatch, SetStateAction, useState } from 'react';
import { SelectedUSDT } from '../../Marketplace/Marketplace.styled';
import {
  formatUSD,
  SendingTokenType,
  wallets
} from '../../../helpers/helperFunctions';
import { P3 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';
import { useTranslation } from 'react-i18next';
import { SelectNetwork } from '../../../components';
import { WalletsType } from '../../../types/types';
import { SelectToken } from '../../../components/common/SelectNetwork/SelectToken';
import { Tokens } from '../../Marketplace/Maeketplace.types';
import { CheckText } from '../../../components/common/CheckText';
import { Button } from '../../../styles/GlobalComponents';
import { PurchaseEarnBetSteps } from '../EarnBet.types';
import { transferToEarnBet } from '../../Earnings/TranferToEarnBet/Transfer.actions';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import { EarnBetTransfer } from '../../Earnings/TranferToEarnBet/Transfer.types';

interface ConfirmDepositProps {
  setTransferStep: Dispatch<SetStateAction<number>>;
  price: number;
}

export const SelectPayment = ({
  price,
  setTransferStep
}: ConfirmDepositProps) => {
  const [selectedNetwork, setSelectedNetwork] = useState<any>(wallets[0]);
  const [selectedToken, setSelectedToken] = useState<any>();
  const [checkbox, setCheckbox] = useState(false);
  const dispatch = useDispatch();
  const { loading } = useAppSelector((state) => state.earnings);
  const { t } = useTranslation('marketplace');

  return (
    <>
      <P3 bold mb='8' mt='30'>
        Remaining payment amount
      </P3>
      <SelectedUSDT>{formatUSD(price)}</SelectedUSDT>
      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {t('selected_network')}
      </P3>
      <SelectNetwork
        disabled
        onChange={(n) => setSelectedNetwork(n)}
        value={selectedNetwork}
      />
      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {t('select_token')}
      </P3>
      <SelectToken
        onChange={(token) => {
          setSelectedToken(token);
        }}
        value={selectedToken}
      />
      {selectedNetwork && (
        <P3 bold mb='25' color={color.colors.error500}>
          <SendingTokenType network={selectedNetwork?.networkType} />
        </P3>
      )}

      {selectedNetwork && (
        <CheckText
          checked={checkbox}
          onClick={() => setCheckbox(!checkbox)}
          text={t('payment_method.i_understand')}
        />
      )}

      <Button
        disabled={
          !selectedNetwork ||
          !checkbox ||
          !selectedToken ||
          Number(price) < 10 ||
          loading
        }
        mt='20'
        onClick={() => {
          dispatch(
            transferToEarnBet({
              cash: 0,
              usdt: selectedToken.index === Tokens.TETHER ? Number(price) : 0,
              usdc: selectedToken.index === Tokens.USDC ? Number(price) : 0,
              networkType: selectedNetwork.networkType,
              isEarnBetTransfer: EarnBetTransfer.isEarnBetTransfer,
              setTransferStep: setTransferStep
            })
          );
        }}>
        Create order
      </Button>
    </>
  );
};
